var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 84,
    viewBox: "0 0 60 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.757696L39.31 27.3556L39.3391 27.4388L39.4139 27.4853L59.5268 40.001L39.4139 52.5166L39.3391 52.5632L39.31 52.6463L30 79.2443L20.69 52.6463L20.6609 52.5632L20.5861 52.5166L0.473191 40.001L20.5861 27.4853L20.6609 27.4388L20.69 27.3556L30 0.757696Z",
    fill: "#A9CF54",
    stroke: "#669005",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1351 54.001L50.3601 64.228L57.2703 69.001L50.3601 73.7739L47.1351 84.001L43.9102 73.7739L37 69.001L43.9102 64.228L47.1351 54.001Z",
    fill: "#669105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.8380d817fcca357f670bb19351b7236c.svg";
export { ForwardRef as ReactComponent };